import DagobahModel from '@/models/DagobahModel.ts';

export const CDN = "/assets/";
export const resolution = DagobahModel.getInstance().resolution;